type LangKey<T extends string> = `${T}En` | `${T}Zh`

export function useLocale() {
  const { locale } = useI18n()

  /** 返回目前語言代碼 (API 使用) */
  function getLangText<T extends Record<string, any>, K extends string>(
    data: T,
    key: K
  ): T[LangKey<K>] {
    const langKey = locale.value === 'en' ? `${key}En` : `${key}Zh`
    return data[langKey as LangKey<K>]
  }

  return {
    getLangText
  }
}
